import { STATS_CATEGORY_IDS } from 'widgets/statspro/js/components/common/config/performance-stats';

export const composeCareerData = (
    playerData,
    nav,
    isUsingNonBenchmarkedData
) => {
    let composedData = [];

    if (playerData.yearly) {
        composedData = playerData.yearly.map((item) => ({
            name:
                item.seasonId === 'CD_S2101264'
                    ? '2022'
                    : item.seasonId?.substr(4, 4),
            playerOneValue: isUsingNonBenchmarkedData
                ? item.seasonStats[STATS_CATEGORY_IDS[nav.category]]
                : item.seasonTotals[STATS_CATEGORY_IDS[nav.category]],
            benchmark: isUsingNonBenchmarkedData
                ? ''
                : item.benchmarkedSeasonAverages[
                      STATS_CATEGORY_IDS[nav.category]
                  ].benchmark ?? '',
            seasonId: item.seasonId
        }));
    }

    return composedData;
};
